export var DynamoDbProjectionType;
(function (DynamoDbProjectionType) {
    DynamoDbProjectionType["DYNAMODB_PROJECTION_TYPE_ALL"] = "ALL";
    DynamoDbProjectionType["DYNAMODB_PROJECTION_TYPE_KEYS_ONLY"] = "KEYS_ONLY";
    DynamoDbProjectionType["DYNAMODB_PROJECTION_TYPE_INCLUDE"] = "INCLUDE";
})(DynamoDbProjectionType || (DynamoDbProjectionType = {}));
